@if (!userService.isLoggedin) {
  <div class="single_page_wrapper d-flex flex-column">
    <div class="logo_header text-center p-2">
      <a href="/" title="Family Central logo"><img src="/assets/images/familycentral-logo.svg" width="155" height="87" alt="Family Central" /></a>
    </div>
    <div class="single_page_body d-flex justify-content-center align-items-center flex-grow-1">
      <div class="single_page_content">
        <form id="msform" method="post" name="registration">
          @if (familyInviationService?.FcInvitationDetails?.status!=1 || !familyInviationService?.FcInvitationDetails?.Isdeleted) {
            <div class="card_header">
              <h2 class="h2 text-center">Welcome to Family Central TPA</h2>
              <p class="invitefamily_content" style="text-align: left;">
                Your Client <span class="text-capitalize">{{familyInviationService?.FcInvitationDetails?.senderName}}</span> would like you to experience Family Central. Below are the steps of how you can experience it.<br>
                1. Please click on the button below to accept the Invite as Trusted Professional Advisor.<br>
                2. For the sign-up you will need a valid email address and an active phone number. You will need this to ensure that your information is kept private to with you.<br>
                3. Once you accept and complete on boarding process, your Client will be notified that you are ready to receive documents or information from them in a secure manner.<br>
                4. You can upload files to your Client which can be viewed in the Personal vault. This is where you are sharing information or documents with the Client.<br>
                5. Please ensure you check the "Shared with me" tab in the your client's Files section to view files shared by them through a link.<br>
                6. At any point if you need further assistance please reach out to Customer Care by calling <a href="tel:1-888-780-3264">1-888-780-3264</a>
              </p>
            </div>
            <div class="form-group submit_btn text-center mt-3">
              <a class="primary_btn" routerLink="/professional/signup">Accept Invite</a>
            </div>
          } @else {
            <div class="text-center mb-4">
              <h2 class="h2">Link Expired</h2>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
}
